/**
 * Class accordion
 */
class NumberAccordion {
	transition: number;
	trigger: JQuery;
	accordion: JQuery;
	wrapper: JQuery;
	top: JQuery;
	bottom: JQuery;

	constructor(element: JQuery) {
		this.accordion = element;
		this.trigger = this.accordion.find('.accordion__top');
		this.top = this.accordion.find('.block-number-accordion__top');
		this.bottom = this.accordion.find('.block-number-accordion__bottom');
		this.wrapper = this.accordion.find('.block-number-accordion__wrapper--left');
		this.trigger.on('click', this.handleClick.bind(this));
		this.transition = 400;

		this.resizeBottom();
		this.init();
	}

	/**
	 * Initialize accordion in collapsed state
	 */
	init() {
		this.accordion.attr('aria-expanded', 'false').removeClass('accordion--expanded');
		this.accordion.find('.accordion__collapsable').hide();
	}

	/**
	 * Initialize bottom element's margin top
	 */
	resizeBottom() {
		let distance = 0;

		if (window.innerWidth > 768) {
			distance =
				(this.wrapper?.height() ?? 0) -
				(this.top?.outerHeight() ?? 0) -
				(this.bottom?.outerHeight() ?? 0);
		}

		this.bottom.css('marginTop', distance);
	}

	/**
	 * Handle bellow click
	 *
	 * @param {Event} event
	 */
	handleClick(event: Event) {
		const target = event.currentTarget as Element;

		const isExpanded = target?.closest('.accordion')?.classList.contains('accordion--expanded');

		if (isExpanded) {
			this.collapseContent(target);
		} else {
			this.expandContent(target);
		}
	}

	/**
	 * Collapse Bellow
	 *
	 * @param {HTMLElement} element Event target
	 */
	collapseContent(element: Element) {
		const accordion = $(element).closest('.accordion');
		const collapsable = accordion.find('.accordion__collapsable');

		accordion.attr('aria-expanded', 'false').removeClass('accordion--expanded');
		collapsable.slideUp(this.transition);
	}

	/**
	 * Expand Bellow
	 *
	 * @param {HTMLElement} element Event target
	 */
	expandContent(element: Element) {
		const accordion = $(element).closest('.accordion');
		const collapsable = accordion.find('.accordion__collapsable');

		// Expand bellow.
		accordion.attr('aria-expanded', 'true').addClass('accordion--expanded');
		collapsable.slideDown(this.transition);
	}

	debounce(func: () => void, wait: number): () => void {
		let timeout: number;
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout);
				func(...args);
			};
			clearTimeout(timeout);
			timeout = window.setTimeout(later, wait);
		};
	}
}

const numberAccordions: NumberAccordion[] = [];
$('.block-number-accordion').each(function () {
	const numberAccordionInstance = new NumberAccordion($(this));
	numberAccordions.push(numberAccordionInstance);
});

$(window).resize(() => {
	numberAccordions.forEach((numberAccordion) => numberAccordion.resizeBottom());
});
